export * from './app.models';
export * from './account.models';
export * from './core.models';
export * from './dashboard.models';
export * from './report.models';
export * from './shipment.models';
export * from './customer.models';
export * from './admin-customer.models';
export * from './shared.models';
export * from './system-config.models';
export * from './user.models';
export * from './carrier.models';
export * from './setting.model';



// WEBPACK FOOTER //
// ./src/models/index.ts